export default "/static/images/build_roof_9.png?07d036330d40be3a99277faf72c0c18d";